var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublishers2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.249,
    height: 8.881,
    viewBox: "0 0 32.249 8.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9783",
    "data-name": "Group 9783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_90",
    "data-name": "Gruppe 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12770",
    "data-name": "Pfad 12770",
    d: "M505.889,21.2a2.2,2.2,0,0,1,1.733-.22l.291.086a3.362,3.362,0,0,0,.581.11l1.763-2.852v-.1H507.6ZM501.43,18.22v.11l3.036,4.851a4.1,4.1,0,0,1,1.251-1.874c.052-.038.1-.074.156-.111l-1.793-2.974Z",
    transform: "translate(-478.009 -18.22)",
    fill: "#2ed87a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12774",
    "data-name": "Pfad 12774",
    d: "M569.19,129.176V132.5h2.352v-3.486l-.129-.042a2.382,2.382,0,0,0-2.223.2Z",
    transform: "translate(-542.604 -123.623)",
    fill: "#2ed87a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12776",
    "data-name": "Pfad 12776",
    d: "M569.23,86.588h0l.016-.018h0a.057.057,0,0,1,.014-.014,2.4,2.4,0,0,1,.233-.221l.014-.012.054-.042.027-.023a2.267,2.267,0,0,1,.254-.164.888.888,0,0,1,.088-.047l.01-.006.014-.006c.025-.013.052-.024.076-.035a.1.1,0,0,1,.023-.01l.069-.027a.118.118,0,0,1,.025-.01.757.757,0,0,1,.079-.027l.026-.008h.01l.047-.012.055-.014h.02a.755.755,0,0,1,.09-.019h.012a.887.887,0,0,1,.1-.016h.032l.079-.006h.131a2.442,2.442,0,0,1,.75.124c.076.029.153.052.221.074,1.113.309,2.015-.307,2.744-1.686a3.737,3.737,0,0,1-2.268.064C570.826,83.9,569.867,84.7,569.23,86.588Z",
    transform: "translate(-542.642 -81.183)",
    fill: "#2ed87a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12777",
    "data-name": "Pfad 12777",
    d: "M1.66,36.428H0V28.75a.62.62,0,0,1,.619-.62H1.661v3.32H4.977V28.13H6.636v7.679a.619.619,0,0,1-.619.619H4.976V33.112H1.659Z",
    transform: "translate(0 -27.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12778",
    "data-name": "Pfad 12778",
    d: "M304.8,79.335H303.22v-6.2h.382l.52.734A2.8,2.8,0,0,1,306,73.151h1.393v1.574H306a1.183,1.183,0,0,0-.467.093,1.171,1.171,0,0,0-.64.636,1.193,1.193,0,0,0-.093.467Z",
    transform: "translate(-289.057 -70.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12779",
    "data-name": "Pfad 12779",
    d: "M412.1,25.772a3.468,3.468,0,0,1-.25,1.332,3.159,3.159,0,0,1-.677,1.028,3.03,3.03,0,0,1-1,.67,3.216,3.216,0,0,1-1.235.237,3.112,3.112,0,0,1-2.917-1.95,3.41,3.41,0,0,1-.25-1.316V20.26h1.591v2.892a1.429,1.429,0,0,1,.311-.289,1.848,1.848,0,0,1,.394-.208,2.536,2.536,0,0,1,.441-.125,2.328,2.328,0,0,1,.441-.044,3.12,3.12,0,0,1,1.234.246,3.087,3.087,0,0,1,1,.687,3.276,3.276,0,0,1,.677,1.039,3.394,3.394,0,0,1,.24,1.313Zm-1.592,0a1.75,1.75,0,0,0-.124-.666,1.657,1.657,0,0,0-.339-.534,1.535,1.535,0,0,0-.5-.353,1.483,1.483,0,0,0-.611-.128,1.357,1.357,0,0,0-.611.14,1.661,1.661,0,0,0-.5.374,1.746,1.746,0,0,0-.331.538,1.688,1.688,0,0,0-.121.627,1.8,1.8,0,0,0,.121.661,1.664,1.664,0,0,0,.331.534,1.6,1.6,0,0,0,.5.356,1.5,1.5,0,0,0,1.221,0,1.6,1.6,0,0,0,.5-.356,1.69,1.69,0,0,0,.338-.534,1.742,1.742,0,0,0,.124-.661Z",
    transform: "translate(-386.813 -20.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12780",
    "data-name": "Pfad 12780",
    d: "M165.535,74.953h-4a1.578,1.578,0,0,0,.482,1.068,1.692,1.692,0,0,0,1.121.331,2.985,2.985,0,0,0,.944-.155,3.06,3.06,0,0,0,.857-.441l.5,1.261a3.417,3.417,0,0,1-1.1.553,4.36,4.36,0,0,1-1.294.2,3.388,3.388,0,0,1-2.444-.856,3.075,3.075,0,0,1-.894-2.332,3.463,3.463,0,0,1,.386-1.661,2.839,2.839,0,0,1,1.074-1.133,3.023,3.023,0,0,1,1.564-.41,2.62,2.62,0,0,1,2.044.838,3.27,3.27,0,0,1,.76,2.274Zm-3.607-1.931a1.7,1.7,0,0,0-.394.992h2.414a1.654,1.654,0,0,0-.331-1,1.042,1.042,0,0,0-.831-.338A1.114,1.114,0,0,0,161.928,73.021Z",
    transform: "translate(-152.247 -68.894)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishers2);
export default __webpack_public_path__ + "static/media/publishers2.73153b92a402dd6e410bd929d3c33a7e.svg";
export { ForwardRef as ReactComponent };